
<div class="ml-3">
    <a @click="onMenu">
        <div class="nav-dropdown" >
            <v-icon color="primary" class="nav-icon mr-2">mdi-clipboard-outline</v-icon>
            <v-badge :content="total" :color="totalColor" :tile="true">  </v-badge>
            <i class="nav-icon fas fa-caret-down" style="margin-left: 25px; font-size: 22px!important;"></i>
        </div>
    </a>
</div>
